import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import TrackingNumberItem from "./TrackingNumberItem";

ReturnTrackingNumber.propTypes = {
    currentOrganization: PropTypes.object,
    returnShipment: PropTypes.object,
};

function ReturnTrackingNumber({returnShipment, currentOrganization, index = null}) {
    const [returnTrackingNumber, setReturnTrackingNumber] = React.useState(null);
    const [returnShipmentLabel, setReturnShipmentLabel] = React.useState(null);

    useEffect(() => {
        // legacy system
        if (returnShipment.returnTrackingNumber) {
            setReturnTrackingNumber(returnShipment.returnTrackingNumber)
        } else if (returnShipment.return) { // new system
            setReturnTrackingNumber(returnShipment.trackingNumber)
        }

        const returnShipmentLabels = getShipmentDocument(returnShipment)

        if (returnShipmentLabels && returnShipmentLabels.length) {
            setReturnShipmentLabel(returnShipmentLabels[0]);
        }

    }, [returnShipment]);

    function getShipmentDocument(shipment) {
        if (!shipment || !shipment.documents) {
            return null;
        }

        return Object.values(shipment.documents).filter(item => item['type'] === "return-waybill")
    }

    if (!returnShipment) {
        return null;
    }

    return (
        <TrackingNumberItem
            index={index}
            trackingNumber={returnTrackingNumber}
            document={returnShipmentLabel}
            documentUrl={returnShipmentLabel && returnShipmentLabel['url']}
            currentOrganization={currentOrganization}
            type={'return'}
        />
    );
}

export default ReturnTrackingNumber;
